import { Domains, Countries, AirportData } from "@/core/types/types";
import {
  getTopLevelDomain,
  fetchWithAbort,
  getCountryByDomain,
  processApiResponse,
} from "@/core/utils";
const fetchOptions: object = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const getAirports = async (
  airport: string = "",
  abortSignal: AbortSignal
): Promise<{
  airports: AirportData[];
  message?: string;
}> => {
  const tld: Domains | string = getTopLevelDomain();
  const country: Countries = getCountryByDomain(tld as Domains);
  const response: Response = await fetchWithAbort(
    "api/getAirports?" + new URLSearchParams({ airport, country }),
    {
      ...fetchOptions,
      abortSignal,
      method: "GET",
    }
  );

  return processApiResponse(response);
};
